import loader from './loader.json';

export const animationsBcp = {
	loader,
};
